export enum SupplierStatus {
  Active = "Active",
  Disabled = "Disabled",
  Archived = "Archived",
}
